'use client';

import { ReactNode } from 'react';
import { Text } from '../text/text';
import { Button } from '../button/button';
import { Flex } from '../flex/flex';
import { Card } from '../card/card';
import { Box } from '../box/box';
import { Copy } from 'lucide-react';
import { themeVars } from '@instamenu/ui-vanilla-extract';
import { useCopyToClipboard } from '@instamenu/react-hooks';
import { useLocale } from '@instamenu/context-i18n';
import { toast } from 'react-hot-toast';
import { LinkNext } from '../link/link';
import { copyableUrl, copyableUrlLink } from './url-bar.css';
import clsx from 'clsx';

export interface UrlBarProps {
  baseUrl?: string;
  path?: string;
  onCopySuccess?: () => void;
  actions?: ReactNode;
  containerStyle?: React.CSSProperties;
  className?: string;
  link?: boolean;
}

export const UrlBar = ({
  baseUrl,
  path,
  onCopySuccess,
  actions,
  containerStyle,
  className,
  link = false,
}: UrlBarProps) => {
  const { i18n } = useLocale();
  const { copy } = useCopyToClipboard({
    onSuccess: () => {
      toast.success(i18n.t('settings.restaurantSettings.copied'));
      onCopySuccess?.();
    },
  });

  if (!baseUrl) return null;

  const finalUrl = new URL(path ?? '', baseUrl).href;

  return (
    <Card
      className={clsx(copyableUrl, className)}
      css={{
        ...containerStyle,
      }}
    >
      <Flex css={{ gap: 6, alignItems: 'center', justifyContent: 'space-between' }}>
        <Box style={{ overflowX: 'auto' }}>
          {link ? (
            <LinkNext href={finalUrl} className={copyableUrlLink} target="_blank">
              {finalUrl}
            </LinkNext>
          ) : (
            <Text className={copyableUrlLink}>{finalUrl}</Text>
          )}
        </Box>
        <Flex css={{ gap: themeVars.pad[12], alignItems: 'center', alignSelf: 'flex-start' }}>
          <Button size="xs" variant="secondary" onClick={() => copy(finalUrl)}>
            <Copy width={16} height={16} />
          </Button>
          {actions}
        </Flex>
      </Flex>
    </Card>
  );
};
